/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartCheckoutOfferButton_transaction$ref: FragmentReference;
export type CartCheckoutOfferButton_transaction = {|
  +hasDealerSubmittedOfferAction: ?boolean,
  +hasAcceptedBuyerOfferAction: ?boolean,
  +$refType: CartCheckoutOfferButton_transaction$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartCheckoutOfferButton_transaction",
  "type": "Transaction",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "hasDealerSubmittedOfferAction",
      "name": "hasAction",
      "args": [
        {
          "kind": "Literal",
          "name": "actionCode",
          "value": "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER",
          "type": "String!"
        }
      ],
      "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER\")"
    },
    {
      "kind": "ScalarField",
      "alias": "hasAcceptedBuyerOfferAction",
      "name": "hasAction",
      "args": [
        {
          "kind": "Literal",
          "name": "actionCode",
          "value": "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER",
          "type": "String!"
        }
      ],
      "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5247088894c395c645274a37c5ba5b48';
module.exports = node;
